/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable no-unused-vars */
import { useDispatch, useSelector } from "react-redux";
import Page from "../../components/layout/Page";
import { useState } from "react";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

import { push } from "connected-react-router";
import { PLANS } from "../ResumeBuilder/Components/PurchaseModal/constants";
import Button from "../../components/forms/Button";
import { FiLogOut } from '@react-icons/all-files/fi/FiLogOut';

import "./index.scss";
import { BUTTON_VARIANT_LINK } from "../../components/forms/Button/constants";
import { postRequest } from "../../services/requestService";
import { message } from "antd";
import { getCookie } from "../../services/clientService";


export default props => {
    const location = useLocation();
    const { userDetails } = useSelector(({ AuthReducer }) => AuthReducer);
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    // Helper to get plan label from planId
    const getPlanLabel = (planId) => {
        if (!planId) return '';
        const plan = PLANS.find(p => p.id === planId);
        return plan ? plan.label : 'Monthly';
    };
    const subscription = userDetails?.subscription;
    const fullName = `${userDetails?.firstName || ''} ${userDetails?.lastName || ''}`.trim();
    const email = userDetails?.email || '';
    const planLabel = getPlanLabel(subscription?.planId);
    const isActive = !!subscription?.active;

    const onSignOut = async () => {
        await postRequest('auth/logout')
        window.location.href = '/auth'
    }
    const onManageSubscription = async () => {
        try {
            const formData = {};
            if (getCookie('mode') === 'test') {
                formData.mode = 'test';
            }
            const res = await postRequest('auth/get-subscription-url', formData)
            if (res?.data?.subscriptionUrl) {
                window.location.href = res.data.subscriptionUrl
            }
        }
        catch(e) {
            message.error(`We couldn't find payments or subscriptions associated with your account. Please contact support@getingenie.com if you think we made a mistake.`)
        }
    }

    return (
        <Page className="settings-page">
            <div className="settings-page-header">
                <div>
                    <h1 style={{ display: 'flex', alignItems: 'center' }}>
                        <div>Settings</div>
                    </h1>
                    <p className="subtitle">This is where you can manage your base resumes, profile information and subscription details</p>
                </div>
            </div>
            <div className="settings-card">
                <div className="settings-row">
                    <div>Full name</div>
                    <div>{fullName || '-'}</div>
                </div>
                <div className="settings-row">
                    <div>Email address</div>
                    <div>{email || '-'}</div>
                </div>
                <div className="settings-row">
                    <div style={{ fontWeight: 500, marginBottom: 8 }}>Subscription</div>
                    <div className="subscription-row">
                        <span className="status">{isActive ? 'Active' : 'Inactive'}</span>
                        {planLabel && <span className="plan-label">{planLabel} plan</span>}
                        <Button className="manage-btn" onClick={onManageSubscription}>Manage subscription</Button>
                    </div>
                </div>

            </div>
            <div className="danger-zone">
                    <div className="danger-title"><span role="img" aria-label="shield">🛡️</span> Danger Zone</div>
                    <hr className="danger-divider" />
                    <Button variant={BUTTON_VARIANT_LINK} className="signout-btn" onClick={onSignOut}>
                        <FiLogOut style={{ marginRight: 8, fontSize: 20 }} /> Sign Out
                    </Button>
                </div>
        </Page>
    );
};